import { useSnapshot } from "valtio";

import React from "react";

import { kioskStore, setStandbyStateScreenItems } from "@pages/Kiosk/store";

import { StandbyStateScreenTable } from "./StandbyStateScreenTable";

export function StandbyStateScreen(): JSX.Element {
    const { localProject, isProjectMustBeUpdated } = useSnapshot(kioskStore);

    React.useEffect(() => {
        setStandbyStateScreenItems(
            (
                localProject.template.content
                    .standbyStateScreen as StandbyStateScreenItemsType
            ).items as StandbyScreenItemType[]
        );
    }, [isProjectMustBeUpdated]);

    return <StandbyStateScreenTable />;
}
